<div class="content">
  @if (isPagesDev) {
    <div class="notice-banner">
      <h4 class="notice-banner__title">
        Oops. You're using an old link to the Sky Planner.<br/>
        Please visit the official <a class="atmos-text-link" href="https://sky-planner.com/">https://sky-planner.com/</a>.
      </h4>
    </div>
  }

  @if (isSandbox) {
    <div class="notice-banner">
      <h4 class="notice-banner__title">You're on the sandbox version of the Sky Planner.</h4>
      <p class="notice-banner__body">
        This version supports loading unverified content from other users. This should only be used for testing purposes.<br/>
        If you are simply trying to use the Sky Planner, please return to <a class="atmos-text-link" href="https://sky-planner.com/">https://sky-planner.com/</a>.
      </p>
    </div>
  }

  @if (showDataLoss) {
    <div class="notice-banner notice-banner--danger">
      <mat-icon>priority_high</mat-icon>
      <span>Data was changed in another tab. Please refresh this tab to avoid losing changes!</span>
    </div>
  }
  <router-outlet></router-outlet>
</div>

@if (showKeyboardShortcuts) {
  <app-overlay (close)="showKeyboardShortcuts=false" [title]="'Keyboard shortcuts'">
    <app-keyboard-shortcuts (close)="showKeyboardShortcuts=false"></app-keyboard-shortcuts>
  </app-overlay>
}
